import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "../../data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-b border-white/10 py-2.5" : "bg-navy/40 backdrop-blur-md py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a href="#home" data-testid="logo-link" className="flex items-center gap-3 group">
          <img src="/logo.webp" alt="Binara Labs" className="w-10 h-10 object-contain group-hover:scale-110 transition-transform duration-300" />
          <span className="font-heading font-extrabold tracking-tight text-lg leading-none">
            BINARA<span className="text-gold">.</span>LABS
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="relative text-sm font-body text-slate-300 hover:text-white transition-colors after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-gold hover:after:w-full after:transition-all after:duration-300"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-cta"
          className="hidden lg:inline-flex items-center rounded-full bg-gold px-6 py-2.5 text-sm font-body font-bold text-navy hover:shadow-[0_0_28px_rgba(212,175,55,0.5)] hover:-translate-y-0.5 transition-all duration-300"
        >
          Jalin Kerja Sama
        </a>

        <button data-testid="mobile-menu-toggle" aria-label="Menu" onClick={() => setOpen((v) => !v)} className="lg:hidden text-white p-2">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden overflow-hidden glass border-t border-white/10"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <a key={n.href} href={n.href} onClick={() => setOpen(false)} className="text-slate-200 font-body py-1" data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
                  {n.label}
                </a>
              ))}
              <a href="#contact" onClick={() => setOpen(false)} className="mt-2 rounded-full bg-gold px-6 py-3 text-center font-bold text-navy" data-testid="mobile-cta">
                Jalin Kerja Sama
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
